import React from 'react';
import { capitalize } from '../utils/formatters';
import { STATUS_STYLES, URGENCY_BADGE_STYLES } from '../utils/constants';

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${STATUS_STYLES[status]}`}>
    <span className="w-1.5 h-1.5 rounded-full bg-current" />
    {capitalize(status)}
  </span>
);

export const UrgencyBadge = ({ urgency }) => (
  <span className={`inline-block px-2 py-0.5 rounded text-[11px] font-semibold uppercase tracking-wide ${URGENCY_BADGE_STYLES[urgency]}`}>
    {capitalize(urgency)}
  </span>
);
